import { Alert } from '@creditornot/cb-alert';
import { Spinner } from '@creditornot/cb-progress';
import { Modal } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { DecodedValueMap } from 'use-query-params';

import { PurchaseItem } from 'apis/merchant-gateway/merchant-analytics/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import PurchaseItemDetailsV2 from 'modules/purchases/PurchaseItemDetail';
import { useItemOptions } from 'modules/purchases/hooks/useItemOptions';

import { IsoDateRange } from './FilterDateRangePicker';
import { PurchasesQueryConfig } from './purchasesQueryConfig';

const SpinnerContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  padding-block-start: 32px;
`;

const ErrorAlert = styled(Alert).attrs({ variant: 'error' })`
  margin: 12px;
  height: 100px;
  max-width: 95%;
`;

type PurchaseItemDetailLoaderV2Props = {
  onClose: () => void;
  selectedItem: PurchaseItem;
  venue: Venue;
  dateRange: IsoDateRange;
  query: DecodedValueMap<PurchasesQueryConfig>;
};

const PurchaseItemDetailLoader = ({
  onClose,
  selectedItem,
  dateRange,
  query,
  venue,
}: PurchaseItemDetailLoaderV2Props) => {
  const { data, isError, isLoading } = useItemOptions({
    selectedItem,
    venue,
    dateRange,
    query,
  });

  const { currency } = venue;

  return (
    <Modal
      onDismiss={onClose}
      disableContentPadding
      open
      animateOnMount
      sizePreset={{
        desktop: 'sideEndSheet:medium',
        mobile: 'fullScreen',
      }}
    >
      {isLoading ? (
        <SpinnerContainer>
          <Spinner size="large" />
        </SpinnerContainer>
      ) : isError ? (
        <ErrorAlert>
          <FormattedMessage id="errors.unknown-error-retry-contact" />
        </ErrorAlert>
      ) : (
        !isLoading && (
          <PurchaseItemDetailsV2 onClose={onClose} item={selectedItem} itemOptionsV2={data} currency={currency} />
        )
      )}
    </Modal>
  );
};

export default PurchaseItemDetailLoader;
